import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, Row, Col } from 'react-bootstrap';

import * as BECaller from '../../../util/apiCaller';
import { error, setLoading, requestActivation, requestUpgrade } from '../SubscribeActions';
import Loading from '../../../components/Loading/Loading';
import RadioButton from '../../../components/RadioButton/RadioButton';

import '../Subscribe.scss';

const BraintreeClient = require('braintree-web/client');
const BraintreeHostedFields = require('braintree-web/hosted-fields');
const BraintreeThreeDS = require('braintree-web/three-d-secure');
const BraintreePaypal = require('braintree-web/paypal-checkout');

class PaymentMethod extends Component {
  instance;
  client;
  static defaultProps = {
    onNext: () => {},
    onBack: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      clientToken: null,
      sent: false,
      paymentError: undefined,
      type: 'card'
    };

    this.handleNextClick = this.handleNextClick.bind(this);
  }

  componentDidMount() {
    BECaller.api(`billing/getToken`, 'get').then(res => {
      BraintreeClient.create(
        {
          authorization: res.token
        },
        (err, clientInstance) => {
          if (err) {
            console.error(err);
            return;
          }

          this.client = clientInstance;
          this.setState({ clientToken: res.token });
          this.createCheckout();
        }
      );
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sent != this.props.sent && this.props.sent === true) {
      this.setState({
        sent: this.props.sent
      });
    }
    if (prevProps.paymentError != this.props.paymentError) {
      this.setState({
        paymentError: this.props.paymentError
      });
    }
  }

  componentWillUnmount() {
    if (this.instance) {
      this.instance.teardown();
    }
  }

  redirect() {
    if (this.state.sent === true && this.state.paymentError) {
      this.props.onBack();
    } else if (this.state.sent === true && !this.state.paymentError) {
      this.props.router.push('/');
    }
  }

  handlePayment(err, payload) {
    if (err) {
      if (err.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT') {
        return false;
      }

      console.error(err);
      if (err.details && err.details.originalError) {
        let msg = err.details.originalError.description;
        if (err.details.originalError.details) {
          msg = err.details.originalError.details.originalError.error.message;
        }
        this.props.setError(msg);
      } else {
        this.props.setError('Invalid 3DS', { details: err });
      }
      this.props.setLoading(false);
    }

    const model = {
      ...this.props.model,
      type: this.state.type,
      nonce: payload.nonce
    };
    this.props.requestActivation(model).then(() => this.redirect());
  }

  handleNextClick() {
    if (this.props.paymentLoading) {
      return false;
    }

    this.props.setLoading(true);
    this.instance
      .tokenize()
      .then(res => {
        const { model, user } = this.props;

        if (model.threeDS) {
          this.threeDSecure.verifyCard(
            {
              exemptionRequested: true,
              amount: model.total,
              nonce: res.nonce,
              email: user.email,
              billingAddress: {
                givenName: model.firstName,
                surname: model.lastName,
                streetAddress: model.address,
                locality: model.city,
                countryCodeAlpha2: model.country
              },
              onLookupComplete: (data, next) => {
                next();
              }
            },
            (err, payload) => {
              this.handlePayment(err, payload);
            }
          );
        } else {
          this.handlePayment(null, res);
        }
      })
      .catch(err => {
        console.error(err);
        this.props.setError('Invalid payment information');
        this.props.setLoading(false);
      });
  }

  createCheckout() {
    const create = () => {
      if (this.state.type === 'card') {
        this.createHostedFields();
      } else {
        this.createPaypalChekout();
      }
    };

    if (this.instance) {
      this.instance.teardown(create);
    } else {
      create();
    }
  }

  createPaypalChekout() {
    BraintreePaypal.create(
      {
        client: this.client
      },
      (err, paypalCheckoutInstance) => {
        if (err) {
          console.error('Error creating PayPal Checkout:', err);
          return;
        }

        this.instance = paypalCheckoutInstance;
        const { model } = this.props;

        window.paypal.Button.render(
          {
            env: process.env.RUN_ENV === 'production' ? 'production' : 'sandbox',
            commit: true,
            style: {
              color: 'blue',
              shape: 'rect',
              size: 'small',
              height: 42,
              label: 'pay',
              tagline: false
            },
            payment: () => {
              return this.instance.createPayment({
                flow: 'vault',
                amount: model.total,
                currency: 'USD',
                enableShippingAddress: true,
                shippingAddressEditable: false,
                shippingAddressOverride: {
                  recipientName: `${model.firstName} ${model.lastName}`,
                  line1: model.address,
                  city: model.city,
                  countryCode: model.country,
                  postalCode: model.zip,
                  state: model.state
                }
              });
            },
            onAuthorize: (data, actions) => {
              this.props.setLoading(true);
              return this.instance.tokenizePayment(data, (err, payload) => {
                this.handlePayment(err, payload);
              });
            },
            onCancel: data => {
              console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));
            },
            onError: err => {
              console.error('Paypal Checkout error', err);
              this.props.setError(err);
            }
          },
          '#paypal-button'
        ).then(() => {});
      }
    );
  }

  createHostedFields() {
    BraintreeHostedFields.create(
      {
        client: this.client,
        styles: {
          ':focus': {
            color: 'black'
          },
          '.valid': {
            color: '#00506b'
          }
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: '',
            rejectUnsupportedCards: true
          },
          cvv: {
            selector: '#cvv',
            placeholder: '',
            type: 'password'
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YYYY'
          }
        }
      },
      (err, hostedFieldsInstance) => {
        if (err) console.error(err);
        else {
          this.instance = hostedFieldsInstance;
        }
      }
    );

    BraintreeThreeDS.create(
      {
        client: this.client,
        version: 2
      },
      (err, threeDSecureInstance) => {
        if (err) console.error(err);
        else {
          this.threeDSecure = threeDSecureInstance;
        }
      }
    );
  }

  render() {
    if (!this.state.clientToken || (this.state.type === 'paypal' && this.props.paymentLoading)) {
      return <Loading />;
    }

    return (
      <div className='billing_inner_content'>
        <form className='form_billing form_payment' id="cardForm">
          <Row>
            <Col sm={12}>
              <RadioButton
                id="card_payment"
                name="paymenttype"
                label={
                  <div className='details'>
                    <label>Card</label>
                    <div className='card visa'></div>
                    <div className='card mastercard'></div>
                    <div className='card maestro'></div>
                    <div className='card discover'></div>
                    <div className='card american_express'></div>
                  </div>
                }
                value="card"
                checked={this.state.type == 'card'}
                onChange={e => this.setState({ type: e.value }, () => this.createCheckout())}
              />
            </Col>
            {this.state.type === 'card' && (
              <React.Fragment>
                <Col sm={12}>
                  <label>Card number</label>
                  <div id="card-number" className='form-control'></div>
                </Col>

                <Col sm={6}>
                  <label>Expiration date</label>
                  <div id="expiration-date" className='form-control'></div>
                </Col>
                <Col sm={6}>
                  <label>CVV</label>
                  <div id="cvv" className='form-control'></div>
                </Col>
              </React.Fragment>
            )}
            <Col sm={12} className='paypal_container'>
              <RadioButton
                id="paypal_payment"
                name="paymenttype"
                label={
                  <div className='details'>
                    <label>Paypal</label>
                    <div className='card paypal'></div>
                  </div>
                }
                value="paypal"
                checked={this.state.type == 'paypal'}
                onChange={e => this.setState({ type: e.value }, () => this.createCheckout())}
              />
            </Col>
          </Row>
        </form>
        <div className='action_box_billing'>
          <Button variant='secondary' className='btn_prev' onClick={this.props.onBack}>
            Back
          </Button>
          {this.state.type === 'card' && (
            <Button variant='primary' className='btn_next' onClick={this.handleNextClick}>
              {this.props.paymentLoading ? 'Loading...' : 'Finish'}
            </Button>
          )}
          {this.state.type === 'paypal' && (
            <div variant='primary' className='btn_next btn_paypal' id="paypal-button"></div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: (err, opt) => dispatch(error(err, opt)),
    setLoading: value => dispatch(setLoading(value)),
    requestActivation: model => dispatch(requestActivation(model)),
    requestUpgrade: model => dispatch(requestUpgrade(model))
  };
};

const mapStateToProps = state => {
  return {
    model: state.subscription.model,
    user: state.auth.user,
    sent: state.subscription.sent,
    paymentError: state.subscription.error,
    paymentLoading: state.subscription.paymentLoading
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentMethod));
